export default __webpack_public_path__ + "static/media/Grandpa-Bread.b0b4c9c7.jpg";